import { generateURL } from 'utils/helpers';
import { apiSlice } from '.';

apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    nextDepartures: builder.query({
      query: (args) => generateURL('/service/next_departures', args),
      providesTags: ['next_departures'],
      keepUnusedDataFor: 3600,
    }),

    dailyTimetable: builder.query({
      query: (args) => generateURL('/service/daily_timetable', args),
      providesTags: ['daily_timetable'],
      keepUnusedDataFor: 3600,
    }),

    routeServices: builder.query({
      query: ({ routeId, date }) =>
        generateURL(`/route/${routeId}/services`, { date }),
      providesTags: ['route_services'],
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const {
  useNextDeparturesQuery,
  useDailyTimetableQuery,
  useLazyRouteServicesQuery,
} = apiSlice;
